import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import useNfuEntregadoTipo from "../../../hooks/administrador/general/useNfuEntregadoTipo";
import '../../../styles/administrador.css';

const NfuEntregadoTipo = ({ year, mes, token, idAdministrador }) => {
  const chartRef = useRef(null);
  const data = useNfuEntregadoTipo(year, mes, token, idAdministrador);

  useEffect(() => {
    if (Array.isArray(data) && data.length && chartRef.current) {
      const chartDom = chartRef.current;
      let myChart = echarts.getInstanceByDom(chartDom) || echarts.init(chartDom);
      if (myChart) myChart.dispose();
      myChart = echarts.init(chartDom);
      
       
      const colorPalette = ['#d1dc5a', '#6ac5cb', '#45444e', '#a3b85b', '#3a6b74'];

      let processedData = [];
      let pltTotal = 0;
      let totalNFU = 0;

      data.forEach(item => {
          const value = Number(item.y) || 0;
          totalNFU += value;

          if (item.name === 'PLT' || item.name === 'PLT 2') {
              pltTotal += value;
          } else {
              processedData.push({
                  name: item.name,
                  value: value
              });
          }
      });

      if (pltTotal > 0) {
          processedData.push({
              name: 'PLT',
              value: pltTotal
          });
      }

      const order = ['PLT', 'CVT', 'OTR', 'MOT', 'BICI'];
      processedData.sort((a, b) => order.indexOf(a.name) - order.indexOf(b.name));

      const sortedByValue = [...processedData].sort((a, b) => b.value - a.value);
      const maxValueCategory = sortedByValue.length > 0 ? sortedByValue[0].name : '';

      const finalColors = [...colorPalette];
      if (maxValueCategory === 'PLT') {
          finalColors[order.indexOf('PLT')] = colorPalette[0];
      }

      const option = {
          title: {
              text: 'NFU entregados por tipo',
              left: 'center',
              subtext: `TOTAL RECOLECTADOS: ${totalNFU.toLocaleString()} [U]`,
              subtextStyle: {
                  fontWeight: 'bold',
                  fontSize: '12px'
              },
              textStyle: {
                  fontSize: 18,
                  fontWeight: 'bold'
              }
          },
          tooltip: {
              trigger: 'item',
              formatter: function(params) {
                  return `${params.seriesName}<br/>${params.name}: ${params.value.toLocaleString()} (${params.percent}%)`;
              }
          },
          legend: {
              orient: 'horizontal',
              bottom: 0,
              data: processedData.map(item => item.name),
              textStyle: {
                  fontSize: 12
              }
          },
          color: finalColors,
          series: [{
              name: 'NFU Entregados',
              type: 'pie',
              radius: ['40%', '70%'],
              center: ['50%', '50%'],
              avoidLabelOverlap: true,
              itemStyle: {
                  borderRadius: 10,
                  borderColor: '#fff',
                  borderWidth: 0
              },
              label: {
                  show: false,
                  position: 'outside',
              },
              emphasis: {
                  label: {
                      show: true,
                      fontSize: '13',
                      fontWeight: 'bold',
                      formatter: '{b}'
                  },
                  itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
              },
              labelLine: {
                  show: false
              },
              data: processedData.map((item, index) => ({
                  ...item,
                  itemStyle: {
                      color: finalColors[index % finalColors.length]
                  }
              }))
          }]
      };

      myChart.setOption(option);

      const updateChart = () => {
        myChart.resize();
      };
      
      window.addEventListener('resize', updateChart);
      
      return () => {
        window.removeEventListener('resize', updateChart);
        if (myChart && !myChart.isDisposed()) {
          myChart.dispose();
        }
      };
    }
  }, [data]);

  return <div className="grafica" ref={chartRef}></div>;
};

export default NfuEntregadoTipo;